export const defaultStation = {
    id: "RMision105",
    image:
      "https://firebasestorage.googleapis.com/v0/b/tvmision-e9656.appspot.com/o/stations%2F1055logo_facebook.jpeg?alt=media&token=3c0fd2b9-c9d4-4892-83b9-d10b93dbe117",
    // artwork:
    //   "https://firebasestorage.googleapis.com/v0/b/tvmision-e9656.appspot.com/o/stations%2FRMision105.png?alt=media&token=52caee8d-f11c-4ea7-8bd0-456fc0628cc3",
    ip: "http://155.138.232.105:8000",
    selectedIp: "http://155.138.232.105:8000",
    link: "https://www.facebook.com/mision105.5fm/",
    message: "",
    name: "RMision105",
    title: "TV Mision",
    subTitle: "",
    disabled: false,
  }
  
  export const defaultAdsConfiguration = {
    maxHeight: '10%',
    maxHeightOR: 0,
    adMaxTime: 15,
    borderStyle: "",
    disabled: false,
    showAdOnHome: true,
    showAdOnPlayer: true,
  }
  